module.exports = __webpack_public_path__ + "static/media/arrow-right-hover.1ecec3a3.svg";